import React from "react";

import { CloseOutlined, PaperClipOutlined } from "@ant-design/icons";

const DownloadAttachment = ({
  id,
  downloadAttachments,
  fileName,
  group,
  contentType,
  removeAttachment,
}) => {
  return (
    <div>
      <div key={id} className="div_label_i_dokument">
        <div className="div_dokument">
          <div
            className="div_ikona_tekst"
            onClick={downloadAttachments(group, contentType, fileName, id)}
          >
            <PaperClipOutlined
              style={{ marginRight: "8px", color: "#464646" }}
            />
            {fileName}
          </div>
          <div className="iksic" onClick={removeAttachment(group, id)}>
            <CloseOutlined />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadAttachment;
